<!-- Projected content wrapper -->
<div
  class="fv-loader__body"
  [class.fv-loader__body--loading]="loading()"
  [class.fv-loader__body--overlay]="overlay() && loading()"
  [attr.inert]="loading() || null">
  <ng-content />
</div>

<!-- Spinner -->
@if (loading()) {
  <div class="fv-loader__spinner">
    @switch (variant()) {
      @case ('line-simple') {
        <svg
          class="fv-loader__svg fv-loader__spin"
          [attr.width]="dimension()"
          [attr.height]="dimension()"
          [attr.viewBox]="'0 0 ' + dimension() + ' ' + dimension()">
          <circle
            class="fv-loader__track"
            fill="none"
            [attr.cx]="center()"
            [attr.cy]="center()"
            [attr.r]="radius()"
            [attr.stroke-width]="strokeWidth()" />
          <circle
            class="fv-loader__arc"
            fill="none"
            stroke-linecap="butt"
            [attr.cx]="center()"
            [attr.cy]="center()"
            [attr.r]="radius()"
            [attr.stroke-width]="strokeWidth()"
            [attr.stroke-dasharray]="dashArray()" />
        </svg>
      }
      @case ('line-spinner') {
        <svg
          class="fv-loader__svg fv-loader__spin"
          [attr.width]="dimension()"
          [attr.height]="dimension()"
          [attr.viewBox]="'0 0 ' + dimension() + ' ' + dimension()">
          <circle
            class="fv-loader__track"
            fill="none"
            [attr.cx]="center()"
            [attr.cy]="center()"
            [attr.r]="radius()"
            [attr.stroke-width]="strokeWidth()" />
          <circle
            class="fv-loader__arc"
            fill="none"
            stroke-linecap="round"
            [attr.cx]="center()"
            [attr.cy]="center()"
            [attr.r]="radius()"
            [attr.stroke-width]="strokeWidth()"
            [attr.stroke-dasharray]="dashArray()" />
        </svg>
      }
      @case ('dot-circle') {
        <svg
          class="fv-loader__svg fv-loader__spin"
          [attr.width]="dimension()"
          [attr.height]="dimension()"
          [attr.viewBox]="'0 0 ' + dimension() + ' ' + dimension()">
          @for (dot of dots(); track dot.opacity) {
            <circle
              class="fv-loader__dot"
              [attr.cx]="dot.x"
              [attr.cy]="dot.y"
              [attr.r]="dotRadius()"
              [attr.opacity]="dot.opacity" />
          }
        </svg>
      }
    }

    @if (text()) {
      <span class="fv-loader__text">{{ text() }}</span>
    }
  </div>
}
